import { useRoute, useRouter } from 'vue-router'

export const useMatchRoute = (name: string) => {
  const router = useRouter()

  if (router.hasRoute(name)) {
    const route = useRoute()

    return route.matched.find((r) => r.name === name)
  }

  return null
}

const useFindRoute = (name: string) => {
  const router = useRouter()

  return router.getRoutes().find((r) => r.name === name)
}

const useIncludeRoute = (name: string) => {
  const route = useRoute()

  return route.matched.some((r) => r.name === name)
}

const useRouteHelper = () => {
  return {
    useFindRoute,
    useMatchRoute,
    useIncludeRoute,
  }
}

export default useRouteHelper
